import React from 'react';
import '../../styles/AppLoadingSkeleton.css';

interface Props {
  visible: boolean;
}

const SIDEBAR_ROWS_1 = [70, 85, 60, 90, 75];
const SIDEBAR_ROWS_2 = [80, 65, 70, 55];

const AppLoadingSkeleton: React.FC<Props> = ({ visible }) => {
  return (
    <div className={`als ${visible ? 'als--visible' : 'als--hidden'}`} aria-hidden="true">

      {/* ── Left Sidebar ── */}
      <div className="als__sidebar">
        <div className="als__sidebar-header">
          <div className="als__shimmer als__shimmer--avatar" />
          <div className="als__shimmer als__shimmer--line als__shimmer--w58" />
        </div>

        <div className="als__sidebar-section">
          <div className="als__shimmer als__shimmer--label" />
          {SIDEBAR_ROWS_1.map((w, i) => (
            <div key={i} className="als__sidebar-row">
              <div className="als__shimmer als__shimmer--icon" />
              <div className="als__shimmer als__shimmer--line" style={{ width: `${w}%` }} />
            </div>
          ))}
        </div>

        <div className="als__sidebar-section">
          <div className="als__shimmer als__shimmer--label" />
          {SIDEBAR_ROWS_2.map((w, i) => (
            <div key={i} className="als__sidebar-row">
              <div className="als__shimmer als__shimmer--icon" />
              <div className="als__shimmer als__shimmer--line" style={{ width: `${w}%` }} />
            </div>
          ))}
        </div>
      </div>

      {/* ── Center Panel ── */}
      <div className="als__center">

        {/* TopBar */}
        <div className="als__topbar">
          <div className="als__shimmer als__shimmer--line als__shimmer--topbar-title" />
          <div className="als__topbar-actions">
            <div className="als__shimmer als__shimmer--icon" />
            <div className="als__shimmer als__shimmer--icon" />
            <div className="als__shimmer als__shimmer--avatar als__shimmer--avatar-sm" />
          </div>
        </div>

        {/* Messages */}
        <div className="als__messages">
          {/* AI */}
          <div className="als__msg">
            <div className="als__shimmer als__shimmer--avatar" />
            <div className="als__msg-body">
              <div className="als__shimmer als__shimmer--line als__shimmer--w38" />
              <div className="als__shimmer als__shimmer--line als__shimmer--w72" />
              <div className="als__shimmer als__shimmer--line als__shimmer--w52" />
            </div>
          </div>

          {/* User */}
          <div className="als__msg als__msg--user">
            <div className="als__msg-body als__msg-body--user">
              <div className="als__shimmer als__shimmer--bubble" />
            </div>
            <div className="als__shimmer als__shimmer--avatar" />
          </div>

          {/* AI */}
          <div className="als__msg">
            <div className="als__shimmer als__shimmer--avatar" />
            <div className="als__msg-body">
              <div className="als__shimmer als__shimmer--line als__shimmer--w62" />
              <div className="als__shimmer als__shimmer--line als__shimmer--w85" />
              <div className="als__shimmer als__shimmer--line als__shimmer--w44" />
            </div>
          </div>

          {/* User */}
          <div className="als__msg als__msg--user">
            <div className="als__msg-body als__msg-body--user">
              <div className="als__shimmer als__shimmer--bubble als__shimmer--bubble-sm" />
            </div>
            <div className="als__shimmer als__shimmer--avatar" />
          </div>
        </div>

        {/* Input bar */}
        <div className="als__input-bar">
          <div className="als__shimmer als__shimmer--input" />
          <div className="als__shimmer als__shimmer--strip-btn als__shimmer--strip-btn-round" />
        </div>
      </div>

      {/* ── Right Sidebar (collapsed strip) ── */}
      <div className="als__right">
        <div className="als__shimmer als__shimmer--strip-btn" />
        <div className="als__shimmer als__shimmer--strip-btn" />
        <div className="als__shimmer als__shimmer--strip-btn" />
        <div className="als__shimmer als__shimmer--strip-btn" />
      </div>

    </div>
  );
};

export default React.memo(AppLoadingSkeleton);
